import _ from 'lodash'
import React,{ Component } from 'react'
import { Panel } from 'react-bootstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reduxForm, propTypes,formValueSelector,change } from 'redux-form'
import { PropTypes } from 'prop-types'
import Steps from 'react-steps'
import { fetchEvent,fetchingEvent,fetchActiveSeasons,setWizardStep,resetEventRetrieved } from "../../../../redux/actions/action_event"
import EventInfo from '../EventInfo'
import EventDetails from '../EventDetails'
import LaneConditions from '../LaneConditions'
import EventSetup from '../Setup'
import Participants from '../Participants'
import EventTemplate from '../EventTemplate'
import { EventWizardPage,EventWizardStepDefinition } from '../Constants'
import { eventdefaults , forms } from '../../../../utils/constants'
import { setupComplete } from '../Logic'
import logo from "../../../../images/star-fade.gif"
import EventWizardSteps from './steps'
import { EventWizardState,EventWizardPanel } from './style'
import { default as Fields } from './fields'

const FormName = forms.eventinfo
const { InWizardMode,CurrentWizardStep,EventRetrieved } = Fields

class EventWizard extends Component
{
	static propTypes = {
		...propTypes
	}
	constructor(props)
	{
		super(props)
		this.nextPage      				= this.nextPage.bind(this)
		this.previousPage  				= this.previousPage.bind(this)
		this.saveEvent     				= this.saveEvent.bind(this)
		this.saveEventInfo      	= this.saveEventInfo.bind(this)
		this.saveEventDetails   	= this.saveEventDetails.bind(this)
		this.saveLaneConditions 	= this.saveLaneConditions.bind(this)
		this.saveSetup          	= this.saveSetup.bind(this)
		this.saveParticipants			= this.saveParticipants.bind(this)
		this.goToStep            	= this.goToStep.bind(this)
		this.resetEvent 	= this.resetEvent.bind(this)
		this.setCurrentWizardPage = this.setCurrentWizardPage.bind(this)
		this.activateWizardStep   = this.activateWizardStep.bind(this)
	}
	componentDidMount(){   
		const { eventId,fetchActiveSeasons,fetchEvent,fetchingEvent,dispatch } = this.props
		
		fetchActiveSeasons()

		console.log('Wizard index page eventId', eventId)

		if (eventId > 0) {
			dispatch(fetchingEvent())
			fetchEvent(eventId)
		}
		else {
			dispatch(change(FormName,InWizardMode,true))
		}
	} 
	resetEvent() {
		const { eventRetrieved,dispatch  } = this.props
		if (eventRetrieved === true)
		{        
			dispatch(resetEventRetrieved())
			// once the event is retrieved we then are in wizard mode
			//dispatch(change(FormName,InWizardMode,true))
		}     
	}
	setCurrentWizardPage(step) {
		const { dispatch ,setWizardStep } = this.props
		dispatch(setWizardStep(step))
		//dispatch(change(FormName,CurrentWizardStep,step))
	}
	saveEventInfo()
	{
		//console.log('Saving event info')
		return true
	}
	saveEventDetails()
	{
		// console.log('Saving event details')
		return true
	}
	saveLaneConditions()
	{
		// console.log('Saving lane conditions')
		return true
	}
	saveSetup()
	{
		//  console.log('Saving setup')
		return true
	}
	saveParticipants()
	{
		return true
	}
	saveEvent(step)
	{
		const { EventInfo,EventDetails,LaneConditions,Setup,Participants } = EventWizardPage
	//	console.log('saveEvent')
		switch(step)
		{
			case EventInfo:
			{
				// this.saveEventInfo()
				return true
			}
			case EventDetails:
			{
				// this.saveEventDetails()
				return true
			}
			case LaneConditions:
			{
				// this.saveLaneConditions()
				return true	
			}
			case Setup:
			{
				console.log('saveEvent Setup')
				// this.saveSetup()
				return true		
			}
			case Participants:
			{
				console.log('saveEvent Participants')
				this.saveParticipants()
				return true
			}
		}
		return false
	}
	nextPage() {		
		const currentpage = this.props.currentWizardStep
		console.log('Wizard index currentpage', currentpage)
		if(this.saveEvent(currentpage))
		{
		
			const nextpage = currentpage + 1
			const step = _.find(EventWizardStepDefinition, { step:currentpage })
			step.isDone = true
			step.isActive = false
			
			const nextStep =  _.find(EventWizardStepDefinition, { step:nextpage })
	
			if (nextStep)
			{
					nextStep.isActive = true,
					nextStep.isDone = false
			}
			console.log('Wizard index nextpage', nextpage)
			this.setCurrentWizardPage(nextpage)
		}
	}
	activateWizardStep(currentStep) {

		if ( currentStep != EventWizardPage.EventInfo ) {
			
			const step    = _.find(EventWizardStepDefinition, { step:EventWizardPage.EventInfo })
			step.isDone   = false
			step.isActive = false
			
			const nextStep =  _.find(EventWizardStepDefinition, { step:currentStep })

			if(nextStep)
			{
				nextStep.isActive = true,
				nextStep.isDone = false
			}
		}
	}
	previousPage() {
		const currentpage = this.props.currentWizardStep	
		if(currentpage > 1)
		{
			const nextpage = currentpage - 1
			const step = _.find(EventWizardStepDefinition, { step:currentpage })
			step.isDone = false
			step.isActive = false
			const nextStep =  _.find(EventWizardStepDefinition, { step:nextpage })

			if(nextStep)
			{
				nextStep.isActive = true,
				nextStep.isDone = false
			}
			this.setCurrentWizardPage(nextpage)
		}
	}
	goToStep(step) {	
		const { nextPage,previousPage } = this
		const { onSubmit } = this.props
		//console.log('gotoStep step',step)
		this.resetEvent()
		switch(step) {
			case EventWizardPage.EventInfo:
					return (<EventInfo  onSubmit={nextPage} />)
			case EventWizardPage.EventDetails:
					return (<EventDetails previousPage={previousPage} onSubmit={nextPage}/>)
			case EventWizardPage.LaneConditions:
					return (<LaneConditions previousPage={previousPage} onSubmit={nextPage}/>)
			case EventWizardPage.Setup:
					return (<EventSetup previousPage={previousPage} onSubmit={nextPage}/>)
			case EventWizardPage.Participants:
					return (<Participants previousPage={previousPage} onSubmit={nextPage}/>)
			case EventWizardPage.EventTemplate:
					return (<EventTemplate previousPage={previousPage} onSubmit={onSubmit}/>)
		}
	}
	wizardLandingPage() {
		const { 
			dispatch,
			eventRetrieved,
			eventId,
			currentWizardStep,
			inWizardMode,
			bakergames,
			standardgames,
			isEventInfoVerified,
			isEventDetailsVerified
		} = this.props
		const { isAdministrator } = this.props.user
		
		const { goToStep } = this

		if (eventId == 0) {
			if(inWizardMode) {
				this.activateWizardStep(currentWizardStep) 
				return goToStep(currentWizardStep) 
			}
			else {
				this.activateWizardStep(EventWizardPage.EventInfo) 
				return goToStep(EventWizardPage.EventInfo) 
			}
		}

		let currentStep = currentWizardStep

		if(!isAdministrator)
		{
			if(!isEventInfoVerified)
			{
				currentStep = EventWizardPage.EventInfo
			}
			else if(!isEventDetailsVerified)
			{
				currentStep = EventWizardPage.EventDetails
			}
		}

		
		if(currentWizardStep != undefined) {
			if((eventId > 0) && (inWizardMode)){
				this.activateWizardStep(currentStep) 
				return goToStep(currentStep) 
			}
			else if((eventId > 0) && (eventRetrieved)) {
				let step = currentWizardStep
			
			if((step > EventWizardPage.LaneConditions) && !setupComplete(bakergames,standardgames)) 
				{
					step = EventWizardPage.Setup
					dispatch(setWizardStep(step))
				}
				this.activateWizardStep(step)  
				return goToStep(step) 
			} 
		}
	}
	render()
	{
		const styles = EventWizardState
		const steps  = EventWizardStepDefinition
		const { fetchingevent } = this.props

		console.log('Wizard index fetching event', fetchingevent)
		return ( 
			<div className='pull-left col-sm-12'  >
				<Panel  style= {EventWizardPanel } sm={12}>
					{
						fetchingevent &&
						<div sm={12} style={{ backgroundImage:`url(${logo})`,backgroundRepeat:'no-repeat',height:'400px',width:'400px',margin:'0 auto' }} /> 
					}
					{
						!fetchingevent && (<EventWizardSteps>
							<Steps items={steps} flat  styles={styles} />
						</EventWizardSteps>)
					}
				
					{
						!fetchingevent && this.wizardLandingPage()
					}
				</Panel>
			</div>
		)   
	}
}
EventWizard.propTypes = {
	dispatch:PropTypes.func,
	onSubmit:PropTypes.func,
	fetchingEvent:PropTypes.func,
	setWizardStep:PropTypes.func,
	fetchingEvensetWizardStep:PropTypes.func,
	resetEventRetrieved:PropTypes.func,
	fetchEvent:PropTypes.func,
	fetchActiveSeasons:PropTypes.func,
	eventId:PropTypes.number,
	eventRetrieved:PropTypes.bool,
	inWizardMode:PropTypes.bool,
	currentWizardStep:PropTypes.number,
	bakergames:PropTypes.number,
	standardgames:PropTypes.number,
	isEventInfoVerified:PropTypes.bool,
	isEventDetailsVerified:PropTypes.bool,
	user:PropTypes.object,
	fetchingevent:PropTypes.bool
}
function mapStateToProps(state,ownProps){
	const formName           =  ownProps.form
    const selector           = formValueSelector(formName)
	const eventRetrieved     = selector(state,EventRetrieved)
	const currentWizardStep = selector(state,CurrentWizardStep)
	const inWizardMode 			 = selector(state,InWizardMode)
	const bakergames         = selector(state,'bakergames')
	const standardgames      = selector(state,'standardgames')
	const isEventInfoVerified    = selector(state,'isEventInfoVerified')
	const isEventDetailsVerified = selector(state,'isEventDetailsVerified')
	const fetchingevent = selector(state,'fetchingevent')
  return {
		eventRetrieved,
		currentWizardStep,
		inWizardMode,
		bakergames,
		standardgames,
		user:state.user,
		isEventInfoVerified,
		isEventDetailsVerified,
		fetchingevent
	}
}
function mapDispatchToProps(dispatch){
  return bindActionCreators(
	{
		fetchEvent,
		fetchingEvent,
		fetchActiveSeasons,
		setWizardStep,
		resetEventRetrieved
	},dispatch)
}
export default reduxForm({
  form:FormName,
  initialValues:eventdefaults,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(EventWizard))




// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Wizard/index.js